module.exports = __webpack_public_path__ + "static/media/02-menu.87e56ef2.png";